let table_BillRefund = require("../../templates/table/BillRefund.handlebars");
let $ = require('jquery');
import ModalView from "../comp/ModalView.js";
import i18n from "../../utils/i18n";

let main = function () {
    return ModalView.extend({
        events: {
            'click .btn-confirm': '_submit',
            'click .reasons li': '_reasonSelected'
        },

        render: function () {
            this.$(".modal-body").empty().append((table_BillRefund(this.model.toJSON())));
            this.$(".modal-header").addClass("refundBillHeader");
            this.$(".modal-footer").addClass("refundBillFooter");
            this.$el.modal("show");
            this.confirmButtonName(i18n.msg("pos.bill.refund.label"));
            return this;
        },

        _reasonSelected: function(evt){
            var li = $(evt.currentTarget);
            this.$(".reasons li.active").removeClass("active");
            li.addClass("active");
            if(li.hasClass("others")){
                this.$(".reason-input").show();
            } else {
                this.$(".reason-input").hide();
            }
        },

        _reason: function(){
            var li = this.$(".reasons li.active");
            if(li.hasClass("others")){
                return $.trim(this.$(".reason-other").val());
            } else {
                return $.trim(li.text());
            }
        },

        _submit: function() {
            var reason = this._reason();
            if(reason == ""){
                var alertView = new ModalView({body: "<h3 style='text-align: center; height: 300px; line-height: 250px;'>" + i18n.msg("pos.table.modal.refund.empty") + "</h3>"}).render();
                alertView.$(".modal-footer").hide();
            } else {
                this.model.set({shouldConfirm: true, reason: reason});
            }
        }
    });
};

let exportedValue = main();
export default exportedValue



// WEBPACK FOOTER //
// ./src/view/table/BillRefundModalView.js